import { inject, Injectable } from '@angular/core';
import { UtilityService } from '../../../shared/services/utility.service';
import type { Module } from '../modules/modules.model';

@Injectable({
  providedIn: 'root',
})
export class UserRolesService {
  utilityService = inject(UtilityService);

  defaultOptions = [
    { label: 'Inzien (system)', value: 'read', group: 'Systeem' },
    { label: 'Bewerken (system)', value: 'write', group: 'Systeem' },
    { label: 'Aanmaken (system)', value: 'create', group: 'Systeem' },
    { label: 'Inzien (bedrijf)', value: 'company.read', group: 'Bedrijf/vestiging' },
    { label: 'Bewerken (bedrijf)', value: 'company.write', group: 'Bedrijf/vestiging' },
    { label: 'Aanmaken (bedrijf)', value: 'company.create', group: 'Bedrijf/vestiging' },
    { label: 'Inzien (gebruiker)', value: 'employee.read', group: 'Gebruiker' },
    { label: 'Bewerken (gebruiker)', value: 'employee.write', group: 'Gebruiker' },
    { label: 'Aanmaken (gebruiker)', value: 'employee.create', group: 'Gebruiker' },
    { label: 'Niet tonen in menu', value: 'hide', group: 'Algemeen' },
  ];

  customPermissions: Record<string, { value: string; label: string }[]> = {
    orders: [{ value: 'liveplanning.write', label: 'Live planning bewerken (sync, valideren, publisceren, merge)' }],
    'recurring-order': [
      { value: 'recurringplanning.read', label: 'Terugkerende planning inzien' },
      { value: 'recurringplanning.write', label: 'Terugkerende planning bewerken (sync, split, merge, assign)' },
    ],
  };

  // authorizationService = inject(AuthorizationService);

  // userRoleAdded$ = this.add$.pipe(
  //   concatMap(item =>
  //     this.authorizationService.createRole({ body: item }).pipe(
  //       catchError(err => this.handleError(err)),
  //       map(() => item)
  //     )
  //   ),
  //   share()
  // );
  //
  // userRoleDeleted$ = this.delete$.pipe(
  //   mergeMap(id =>
  //     this.authorizationService.deleteRole({ roleId: id }).pipe(
  //       catchError(err => this.handleError(err)),
  //       map(() => id)
  //     )
  //   ),
  //   share()
  // );
  //
  // userRoleEdited$ = this.edit$.pipe(
  //   mergeMap(update =>
  //     this.authorizationService
  //       .updateRole({ roleId: update.id, body: update.data })
  //       .pipe(
  //         catchError(err => this.handleError(err)),
  //         map(() => update)
  //       )
  //   ),
  //   share()
  // );

  // constructor() {
  //   // reducers
  //   const nextState$ = merge(
  //     this.search$.pipe(map(search => ({ searchTerm: search })))
  //   );
  //
  //   connect(this.state)
  //     .with(nextState$)
  //     .with(this.loaded$, (state, userRoles) => ({
  //       userRoles: userRoles,
  //       loaded: true,
  //     }))
  //     .with(this.userRoleAdded$, (state, item) => ({
  //       userRoles: [...state.userRoles, { ...item, id: Date.now().toString() }],
  //     }))
  //     .with(this.userRoleDeleted$, (state, id) => ({
  //       userRoles: UtilityService.deleteIdFromArray(state.userRoles, id),
  //     }))
  //     .with(this.userRoleEdited$, (state, update) => ({
  //       userRoles: state.userRoles.map(item =>
  //         item.id === update.id
  //           ? {
  //               ...item,
  //               ...(update.data as RoleResponse),
  //             }
  //           : item
  //       ),
  //     }))
  //     .with(
  //       merge(
  //         this.userRoleAdded$,
  //         this.userRoleDeleted$,
  //         this.userRoleEdited$
  //       ).pipe(
  //         switchMap(value => {
  //           return this.authorizationService.getRoles();
  //         })
  //       ),
  //       (state, userRoles) => ({
  //         ...state,
  //         userRoles: userRoles,
  //         loaded: true,
  //       })
  //     );
  //
  //   this.utilityService.notify(this.userRoleAdded$, 'Gebruikersrol aangemaakt');
  //   this.utilityService.notify(
  //     this.userRoleEdited$,
  //     'Gebruikersrol opgeslagen'
  //   );
  //   this.utilityService.notify(
  //     this.userRoleDeleted$,
  //     'Gebruikersrol verwijderd'
  //   );
  // }

  // private handleError(err: any) {
  //   this.state.update(state => ({ ...state, error: err }));
  //   return EMPTY;
  // }

  getDefaultUserRole(modules: Module[]) {
    const defaultUserRole = {
      id: '',
      name: '',
      permissions: [],
    };

    const defaultModuleCodes = ['profile', 'company-settings', 'usersettings'];

    modules.forEach(module => {
      if (defaultModuleCodes.includes(module.code)) {
        defaultUserRole.permissions.push(module.id + '.read');
        defaultUserRole.permissions.push(module.id + '.write');
        defaultUserRole.permissions.push(module.id + '.hide');
      }
    });
    return defaultUserRole;
  }

  checkIfHasViewPermission(permissions: Array<string>, moduleId: string) {
    if (permissions === undefined) {
      return false;
    }

    return permissions.some(permission => permission.includes(moduleId) && permission.includes('.read'));
  }

  checkIfHasEditPermission(permissions: Array<string>, moduleId: string) {
    if (permissions === undefined) {
      return false;
    }

    return permissions.some(permission => permission.includes(moduleId) && permission.includes('.write'));
  }

  checkIfHasCreatePermission(permissions: Array<string>, moduleId: string) {
    if (permissions === undefined) {
      return false;
    }

    return permissions.some(permission => permission.includes(moduleId) && permission.includes('.create'));
  }

  checkHideModuleInMenu(permissions: Array<string>, moduleId: string) {
    if (permissions === undefined) {
      return false;
    }

    return permissions.some(permission => permission.includes(moduleId) && permission.includes('.hide'));
  }

  checkIfHasSystemViewPermission(permissions: Array<string>, moduleId: string) {
    if (permissions === undefined) {
      return false;
    }

    return permissions.some(
      permission =>
        permission.includes(moduleId) &&
        permission.includes('.read') &&
        !permission.includes('.company') &&
        !permission.includes('.employee')
    );
  }

  checkIfHasSystemEditPermission(permissions: Array<string>, moduleId: string) {
    if (permissions === undefined) {
      return false;
    }

    return permissions.some(
      permission =>
        permission.includes(moduleId) &&
        permission.includes('.write') &&
        !permission.includes('.company') &&
        !permission.includes('.employee')
    );
  }

  checkIfHasSystemCreatePermission(permissions: Array<string>, moduleId: string) {
    if (permissions === undefined) {
      return false;
    }

    return permissions.some(
      permission =>
        permission.includes(moduleId) &&
        permission.includes('.create') &&
        !permission.includes('.company') &&
        !permission.includes('.employee')
    );
  }

  checkIfHasCompanyViewPermission(permissions: Array<string>, moduleId: string) {
    if (permissions === undefined) {
      return false;
    }

    return permissions.some(permission => permission.includes(moduleId) && permission.includes('company.read'));
  }

  checkIfHasCompanyEditPermission(permissions: Array<string>, moduleId: string) {
    if (permissions === undefined) {
      return false;
    }

    return permissions.some(permission => permission.includes(moduleId) && permission.includes('company.write'));
  }

  checkIfHasCompanyCreatePermission(permissions: Array<string>, moduleId: string) {
    if (permissions === undefined) {
      return false;
    }

    return permissions.some(permission => permission.includes(moduleId) && permission.includes('company.create'));
  }

  checkIfHasEmployeeViewPermission(permissions: Array<string>, moduleId: string) {
    if (permissions === undefined) {
      return false;
    }

    return permissions.some(permission => permission.includes(moduleId) && permission.includes('employee.read'));
  }

  checkIfHasEmployeeEditPermission(permissions: Array<string>, moduleId: string) {
    if (permissions === undefined) {
      return false;
    }

    return permissions.some(permission => permission.includes(moduleId) && permission.includes('employee.write'));
  }

  checkIfHasEmployeeCreatePermission(permissions: Array<string>, moduleId: string) {
    if (permissions === undefined) {
      return false;
    }

    return permissions.some(permission => permission.includes(moduleId) && permission.includes('employee.create'));
  }
}
